export default "__VITE_ASSET__BPyMcO2$__"